import './App.scss';
import TheApplication from "./components/TheApplication";

function App() {
    return (
        <div className="App">
            <TheApplication />
        </div>
    );
}

export default App;
